import React from "react";
import { Container, Button, Row, Col } from "react-bootstrap";
import { motion } from "framer-motion";
import Features from "./Features";
import WhatCrypto from "./WhatCrypto";
import Stats from "./Stats";
import Leadership from "./Leadership";
import AboutUs from "./AboutUs";
import { useNavigate } from "react-router-dom";

const About = () => {
  const navigate = useNavigate();
  return (
    <div className="main-section">
      {/* Hero Header */}
      <section className="hero-section position-relative overflow-hidden">
        <Container>
          <Row className="justify-content-center">
            <Col md={10} lg={7}>
              <motion.div
                className="section-header text-center"
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.7 }}
              >
                <h2>About Us</h2>
                <p className="lead text-muted">
                  Experience institutional-grade cryptocurrency trading with our
                  proven scalping trading bot averaging 37% monthly returns. Our
                  platform combines cutting-edge technology with OTC pricing
                  access and commodities markets integration, offering a
                  comprehensive solution for both retail and institutional
                  investors.
                </p>
                <p className="lead text-muted">
                  AircliftCapital is a cutting-edge crypto and commodities
                  trading platform designed for traders who demand performance,
                  security, and ease of use. We combine advanced algorithmic
                  trading with deep expertise in global commodities markets,
                  offering a seamless experience from deposit to payout. Our
                  proprietary AI-powered trading bot has a proven track record
                  of optimizing trades, while our team's decades of experience
                  in energy, metals, and agricultural commodities ensures
                  informed, strategic market positioning. Regulatory compliance
                  is at our core—we operate with full transparency to protect
                  your assets and ensure trust.
                </p>
                <p className="lead text-muted">
                  Whether you're a seasoned trader or just starting, [Your
                  Platform Name] makes crypto and commodities trading simple,
                  secure, and successful. Trade Smarter. Trade with Confidence.
                  Key Highlights:
                  <ul className="lead text-muted list-unstyled pt-2 pb-4">
                    <li className="mb-2">
                      ✅ Proven Trading Bot – AI-driven strategies with
                      verifiable results.
                    </li>
                    <li className="mb-2">
                      ✅ Commodities Expertise – Oil, gold, grains, and more.
                    </li>
                    <li className="mb-2">
                      ✅ Regulatory-First Approach – Fully compliant, always
                      secure.
                    </li>
                    <li className="mb-2">
                      ✅ User-friendly, hassle-free transactions.
                    </li>
                  </ul>
                </p>
                <div className="d-flex justify-content-center my-3 text-center">
                  <Button
                    className="btn-polygon btn-lg-lg fw-bold"
                    onClick={() => navigate("/kyc")}
                  >
                    Start Trading Now
                  </Button>
                </div>
              </motion.div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* About Us Section */}
      <AboutUs />

      {/* Leadership Section */}
      <Leadership />

      {/* Features Section */}
      <Features />

      {/* Account Types Section */}
      {/* <AccountTypes /> */}

      {/* What is Crypto */}
      <WhatCrypto />

      {/* Stats Section */}
      <Stats />
    </div>
  );
};

export default About;
